import { FC } from "react";
import { Diagram3, LightningCharge, Trash3 } from "react-bootstrap-icons";
import { Priority, Question } from "../protos/backendproto/QuestionService_pb";

const MAX_CHOICE_CHIPS = 4;

const QuestionCard: FC<{
    hasEditAccess: Boolean,
    question: Question,
    index: number,
    isSelected: Boolean,
    onSelect: () => void,
    onDelete: () => void
}> = (({ hasEditAccess, question, index, isSelected, onSelect, onDelete }) => {
    const choices = question.getChoicesList();
    const actions = question.getActionsList();
    const hasSafetyAction = actions.some((a) => a.getPriority() === Priority.PRIORITY_SAFETY);
    return <div
        className={"q-card" + (isSelected ? " selected" : "")}
        role="button"
        tabIndex={0}
        onClick={onSelect}
        onKeyDown={(e) => { if (e.key === "Enter") onSelect() }}>
        <div className="q-card-top">
            <span className="q-num">{index + 1}</span>
            <div className="q-prompt">{question.getPrompt() || <em className="text-secondary">Untitled question</em>}</div>
            {hasEditAccess && <button className="icon-btn danger hover-reveal" title="Delete question" onClick={(e) => {
                e.stopPropagation()
                onDelete()
            }}><Trash3 size={13} /></button>}
        </div>
        {(choices.length > 0 || actions.length > 0 || question.hasDependentQuestionId()) && <div className="q-meta">
            {choices.slice(0, MAX_CHOICE_CHIPS).map((choice, i) =>
                <span key={choice.getId() + i} className="chip">{choice.getMessage() || "—"}</span>
            )}
            {choices.length > MAX_CHOICE_CHIPS && <span className="chip">+{choices.length - MAX_CHOICE_CHIPS}</span>}
            {question.hasDependentQuestionId() && <span className="chip info" title="Only shown for certain answers to another question">
                <Diagram3 size={11} /> Conditional
            </span>}
            {actions.length > 0 && <span className={"chip " + (hasSafetyAction ? "danger" : "accent")}
                title={`${actions.length} response action${actions.length === 1 ? "" : "s"}${hasSafetyAction ? " (includes safety)" : ""}`}>
                <LightningCharge size={11} /> {actions.length}
            </span>}
        </div>}
    </div>
});

export default QuestionCard
